import { fb, validators } from '../../../../lib/form';

export function getMemberLoginModel(data) {
  const model = fb.group({
    email: [data.email || '', [validators.Required(), validators.Email()], { label: 'Email', type: 'email' }],
  }); 
  return model;
}